import { ContainerComponent } from 'AppReact';
import Controller from './controller';
import { DropdownBodyWrapper, DropdownHeaderWrapper } from './wrappers';
import { SecondaryTextXs } from 'atoms';
import React from 'react';
import internalState from './internalState';

const dropdownRef = React.createRef();

export const definition = {
  name: 'CategoryDropdown',
  controller: Controller,
  initialProps: ({ category, selectedCategoryId, selectedParentId }) => ({ category, selectedCategoryId, selectedParentId }),
  props: internalState,
  elements: [
    {
      wrapper: DropdownHeaderWrapper,
      name: 'Header',
      isButton: true,
      bindings: ({ isOpen }) => ({ isOpen, dropdownRef }),
      displayState: ({ category, selectedParentId }) => ({ selected: category.id === selectedParentId }),
      elements: [
        {
          component: SecondaryTextXs,
          name: 'Text',
          bindings: ({ }) => ({}),
          displayValue: ({ category }) => category.name,
        },
      ]
    },
    {
      wrapper: DropdownBodyWrapper,
      name: 'Body',
      ref: dropdownRef,
      renderIf: ({ isOpen }) => isOpen,
      elements: [
        {
          wrapper: DropdownHeaderWrapper,
          name: 'Children',
          isListOf: 'category.children',
          isButton: true,
          bindings: ({ isOpen, child }) => ({ child, isOpen, dropdownRef }),
          displayState: ({ child, selectedCategoryId }) => ({ selected: child.id === selectedCategoryId }),
          elements: [
            {
              component: SecondaryTextXs,
              name: 'Children',
              displayValue: ({ child }) => child.name
            }
          ]
        },

      ]
    }
  ]
};

const CategoryDropdown = ContainerComponent(definition);

export default CategoryDropdown;